import type { CustomerNotification } from '@/entities/customer-notification/api/customer-notifications/types';
import type { LocalizedString } from '@/shared/model/Language';
import type { Media } from '@/shared/ui/media/types';

export type NewsModalContentProps = {
    notificationId: string;
    media?: Media;
    mediaGallery?: Media[];
    title: LocalizedString;
    content: LocalizedString;
    link?: {
        url: string;
        content: LocalizedString;
    };
};

const toMedia = (fullUrl: string): Media => ({ url: fullUrl, alt: '' });

export const mapCustomerNotificationToNewsModalProps = (
    notification: CustomerNotification,
): NewsModalContentProps => {
    const gallery = (notification.mediaGallery ?? [])
        .filter((item) => Boolean(item.fullUrl))
        .map((item) => toMedia(item.fullUrl));

    return {
        notificationId: notification.id,
        title: notification.title,
        content: notification.content,
        media: notification.media?.fullUrl ? toMedia(notification.media.fullUrl) : undefined,
        mediaGallery: gallery.length > 0 ? gallery : undefined,
        link: notification.ctaUrl
            ? {
                  url: notification.ctaUrl,
                  content: notification.ctaLabel ?? notification.title,
              }
            : undefined,
    };
};
